import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ApiManagerService } from '@ildes/services/api-manager.service';
import { actions, resumedColumns, parse } from './utils';
import { SimpleHeaderComponent } from '@ildes/basic/simple-header/simple-header.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ImagePanelComponent } from '@ildes/basic/image-panel/image-panel.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { BillDetailComponent } from '../bill-detail/bill-detail.component';
const SIZE = 200;

@Component({
  selector: 'app-bills',
  standalone: true,
  imports: [
    CommonModule,
    MatPaginatorModule,
    MatFormFieldModule,
    SimpleHeaderComponent,
    MatProgressBarModule,
    ImagePanelComponent,
    MatButtonModule,
  ],
  template: `<div class="container">
        <simple-header [title]="title" [back]="true" icon="close"></simple-header>
        <section class="filter-container">
          
        </section>
        <h3>Resultados de búsqueda</h3>
        <mat-progress-bar class="margin-top-16" mode="indeterminate" *ngIf="loading"></mat-progress-bar>
        <app-image-panel class="margin-top-16" *ngIf="!parsedItems?.length && !loading"></app-image-panel>
        <div class="container-table" *ngIf="!loading && parsedItems?.length">
          <table [width]="size">
            <tr class="header">
              <th *ngFor="let columnName of header">{{columnName}}</th>
            </tr>
            <tr *ngFor="let row of parsedItems">
              <td *ngFor="let columnValue of row">
                <span *ngIf="!columnValue.config?.link" [innerHTML]="columnValue.value"></span>
                <button (click)="columnAction(columnValue.config.link.action, columnValue.item)" mat-button *ngIf="columnValue.config?.link && columnValue.value">{{columnValue.value}}</button>
              </td>
            </tr>
          </table>
        </div>
        <mat-paginator
          *ngIf="!loading && parsedItems"
          [pageIndex]="currentPage"
          [length]="pagination?.totalDocs"
          pageSize="20"
          (page)="paginate($event)">
        </mat-paginator>
    </div>`,
  styleUrls: ['./bills.component.css']
})
export class BillsComponent implements OnInit {
    public items;
    public loading;
    public parsedItems;
    public currentPage;
    public pagination;
    public size;
    public header;
    public columnsConfig: any;
    public title = 'Precuenta';
    constructor(private apiManager: ApiManagerService, private dialog: MatDialog) {
        this.columnsConfig = resumedColumns;
        this.header = Object.values(this.columnsConfig).map(({name}) => name);
        this.size = `${SIZE * this.header.length}px`;
    }

    ngOnInit(): void {
        this.list();
    }

   list(pageIndex = 0) {
       this.currentPage = pageIndex;
       const page = pageIndex ? { page: pageIndex + 1 } : {};
       let filter: any = this.getFilter();
       filter = {...filter}
       this.loading = true;
       this.fetch(page, filter).subscribe((data: any) => {
         this.loading = false;
         this.items = data?.data;
         if (!this.items) {
           this.pagination = null;
           this.parsedItems = null;
           return;
         }
         this.size = `${SIZE * this.header.length}px`;
         this.parsedItems = parse(this.items, this.columnsConfig);
         this.pagination = data.pagination;
       }, () => {
         this.loading = false;
       });
     }
   
     fetch(page, filter) {
       return this.apiManager.getBills({...page, ...filter});
     }
   
     paginate(event) {
       this.list(event.pageIndex);
     }

     getFilter() {
        return {};
     }

     columnAction (action, bill) {
        switch (action) {
            case actions.seeDetail:
                const dialog = this.dialog.open(BillDetailComponent, {
                    width: '600px',
                    height: '600px',
                    panelClass: 'responsive-dialog',
                    data: { bill }
                });
                break;
        
            default:
                break;
        }
     }
   
}
